import {
  harvestiqEmailAddress,
  harvestiqPhoneNumber,
  InsureIQAppLogoCompactUrl,
  InsureIQAppLogoUrl,
  InsureIQFaviconUrl,
  OrganizationTypes,
} from '@harvestiq/constants';
import { DbAppSettings } from './db-app-settings';
import { defaultColorScheme } from './color-scheme';

export const defaultDbAppSettings: Omit<DbAppSettings, 'id'> = Object.freeze({
  createdAt: new Date(),
  updatedAt: new Date(),
  name: 'HarvestIQ',
  fullLogo: InsureIQAppLogoUrl,
  compactLogo: InsureIQAppLogoCompactUrl,
  favicon: InsureIQFaviconUrl,
  loadingIndicator: 'ring',
  phone: harvestiqPhoneNumber,
  email: harvestiqEmailAddress,
  domain: '',
  sendgridDomainId: null,
  sendgridDomainDns: null,
  colorScheme: defaultColorScheme,
  isActive: null,
  isAdmin: false,
  gaTrackingId: '',
  hubspotAccountId: '',
  hubspotAccessToken: null,
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: '',
  senderEmail: 'no-reply@harvestiq.com',
  timezone: null,
  fmhApiKey: null,
  fmhSigningKey: null,
  organizationType: OrganizationTypes.PRIMARY,
  parentOrgId: null,
  stockguardSlackChannel: null,
  enableNotificationCrons: false,
  enableClaimsUi: true,
  agWorksUsername: null,
  agWorksAlias: null,
  agWorksPassword: null,
  enableSMSCampaigns: false,
  isOrderButtonHidden: false,
  orderButtonText: 'Order',
  twilioSmsSenderNumber: null,
  enableCombinedQuoteCampaignsToSingleEmail: true,
  enableAggregateReports: false,
  disabledAt: null,
  enableCustomSMS: false,
  agencyCampaignMessage: null,
});
